var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class HttpError extends Error {
    constructor(response) {
        // Pass remaining arguments (including vendor specific ones) to parent constructor
        super(`${response.statusText}@${response.url}`);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, HttpError);
        }
        this.name = "HttpError";
        // Custom debugging information
        this.code = response.status;
        this.statusText = response.statusText;
        this.response = response;
        this.body = response.body;
        this.date = new Date();
        this.url = response.url;
    }
    json() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.response.json());
        });
    }
}
